import { Component, OnInit } from '@angular/core'
import {
  UntypedFormBuilder,
  UntypedFormGroup,
  Validators,
} from '@angular/forms'
import { validateAllFormFields } from '../../../../formUtils'
import { CareFinityValidators } from '../../../validators/CareFinityValidators'
import { GlobalSettingsService } from '../../../../api/services'
import { MessageService } from 'primeng/api'

@Component({
  selector: 'app-emergency-token',
  templateUrl: './emergency-token.component.html',
})
export class EmergencyTokenComponent implements OnInit {
  emergencyToken: UntypedFormGroup
  errorValidationSummary: string = ''
  ShowErrorSummary: boolean = false
  constructor(
    private fb: UntypedFormBuilder,
    private globalsettingService: GlobalSettingsService,
    private messageService: MessageService,
  ) {}

  ngOnInit() {
    this.emergencyToken = this.fb.group({
      emergencyToken: ['', Validators.required],
      confirmemergencyToken: ['', Validators.required],
    })

    this.emergencyToken.setValidators(
      CareFinityValidators.Match('emergencyToken', 'confirmemergencyToken'),
    )
  }
  resetToken(): void {
    validateAllFormFields(this.emergencyToken)
    if (this.emergencyToken.invalid) {
      return
    }
    this.globalsettingService
      .globalSettingsPost({
        emergencytoken: this.emergencyToken.get('emergencyToken').value,
      })
      .subscribe((X) => {
        this.messageService.add({
          key: 'alertToast',
          severity: 'success',
          summary: 'Confirmation',
          detail: 'Security Token Updated Successfully',
        })
      })
  }
}
